import React from 'react';

import { CheckEmailsPage } from '@lumapps/login/components/CheckEmailsPage';
import { LoginPage } from '@lumapps/login/components/LoginPage';
import { useSentLinkMessage } from '@lumapps/login/hooks/useSentLinkMessage';
import { StepProps } from '@lumapps/lumx-layouts/types';
import { SIGN_IN } from '@lumapps/sign-in/keys';
import { useTranslate } from '@lumapps/translations';

export const CheckEmailsStep: React.FC<StepProps> = ({ backButton, state, ...props }) => {
    const { translateKey } = useTranslate();
    const message = useSentLinkMessage(state?.email);

    return (
        <LoginPage title={translateKey(SIGN_IN.CHECK_YOUR_EMAILS)} before={backButton} displayPoweredBy={false}>
            <CheckEmailsPage {...props} state={state} message={message} />
        </LoginPage>
    );
};
